import { render, staticRenderFns } from "./EcProducts.vue?vue&type=template&id=0d1a54b4&scoped=true"
import script from "./EcProducts.vue?vue&type=script&lang=js"
export * from "./EcProducts.vue?vue&type=script&lang=js"
import style0 from "./EcProducts.vue?vue&type=style&index=0&id=0d1a54b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1a54b4",
  null
  
)

export default component.exports